/* eslint-disable no-bitwise */
export enum UserFlag {
  RealMoneyOk = 1 << 3,
  AgeVerified = 1 << 12,
  AuthVerified = 1 << 20,
  RSARequired = 1 << 26,
  AccountPINRequired = 1 << 29
}
